"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
const time_1 = require("./time");
function retry(config) {
    return async (...args) => {
        let lastError;
        for (let i = 0; i < config.maxRetries; i++) {
            try {
                return await config.fn(...args);
            }
            catch (e) {
                lastError = e;
                if (!config.disableLog) {
                    console.log(`Function ${config.fn.name} failed. Retrying ${i}/${config.maxRetries} after ${config.waitBetweenMs || 0}`);
                }
                if (config.waitBetweenMs && i === config.maxRetries - 1) {
                    await (0, time_1.sleep)(config.waitBetweenMs);
                }
            }
        }
        if (!config.disableLog) {
            `Function ${config.fn.name} failed after ${config.maxRetries} attempts`;
        }
        throw lastError;
    };
}
exports.retry = retry;
//# sourceMappingURL=retry.js.map